module.exports = __webpack_public_path__ + "img/cartdark.fcd84940.svg";